import React from 'react';

const InfrastructureHealthDataPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Infrastructure Health Data Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-sm text-gray-600 mb-8">
              <strong>GCC-Specific Policy</strong> - This page clarifies how Civioniks/InfraHealth treats infrastructure health monitoring data.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Purpose</h2>
              <p className="text-gray-700 leading-relaxed">
                This page clarifies how Civioniks/InfraHealth treats infrastructure health monitoring data.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Nature of data</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Engineering measurements: strain, stress, vibration, cracks, temperature, flow.</li>
                <li>Not patient or personal health data.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Ownership</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Data belongs to the client/project owner.</li>
                <li>Civioniks acts as a processor/technical custodian.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Use</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Solely for lifecycle monitoring, safety, and analysis.</li>
                <li>No sale, no advertising, no unrelated use.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Compliance</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Saudi PDPL:</strong> local storage when required.</li>
                <li><strong>UAE DPL:</strong> lawful cross-border transfers.</li>
                <li><strong>Other GCC:</strong> aligned with contractual requirements.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Security</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Encryption, isolation, and strict access controls.</li>
                <li>Full audit trails for sensitive project data.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Retention</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Retained only for project duration or legal requirements.</li>
                <li>Deletion or return available on request.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                For infrastructure data issues: hello@civioniks.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfrastructureHealthDataPolicy;
